import { render } from "./ColorChooser.vue?vue&type=template&id=2933e79d&scoped=true"
import script from "./ColorChooser.vue?vue&type=script&lang=js"
export * from "./ColorChooser.vue?vue&type=script&lang=js"

import "./ColorChooser.vue?vue&type=style&index=0&id=2933e79d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2933e79d"]])

export default __exports__